import { render, staticRenderFns } from "./suggestionList.vue?vue&type=template&id=f582068a&scoped=true&"
import script from "./suggestionList.vue?vue&type=script&lang=js&"
export * from "./suggestionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f582068a",
  null
  
)

export default component.exports